/* one% Where To Buy: first-view reveal, off-screen pause for the logo rows, and the
   logo fit that sizes each in-store wordmark from its own shape (Where To Buy.dc.html). */
(() => {
  if (customElements.get('op-where-to-buy')) return;

  // Same maths as the design: aim for ~3400px² of logo, capped at 136 x 46.
  const fitSize = (ratio) => {
    const a = ratio || 3.5;
    let h = Math.sqrt(3400 / a);
    let w = a * h;
    if (w > 136) { w = 136; h = w / a; }
    if (h > 46) { h = 46; w = a * h; }
    return [Math.round(w), Math.round(h)];
  };

  class OpWhereToBuy extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.op-where-to-buy') || this;
      this.fitLogos();
      this.reveal();
      this.watchOffscreen();
    }

    disconnectedCallback() {
      if (this.revealIo) this.revealIo.disconnect();
      if (this.playIo) this.playIo.disconnect();
    }

    fitLogos() {
      this.querySelectorAll('[data-op-fit] img').forEach((img) => {
        const measure = () => {
          if (!img.naturalWidth || !img.naturalHeight) return;
          const [w, h] = fitSize(img.naturalWidth / img.naturalHeight);
          img.style.width = w + 'px';
          img.style.height = h + 'px';
        };
        if (img.complete) measure();
        else img.addEventListener('load', measure, { once: true });
      });
    }

    reveal() {
      const root = this.root;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const editor = window.Shopify && window.Shopify.designMode;
      if (reduce || editor || !('IntersectionObserver' in window)) {
        root.removeAttribute('data-reveal');
        return;
      }
      root.setAttribute('data-reveal', 'pending');
      this.revealIo = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        root.removeAttribute('data-reveal');
        this.revealIo.disconnect();
      }, { threshold: 0.15 });
      this.revealIo.observe(root);
    }

    watchOffscreen() {
      if (!('IntersectionObserver' in window)) return;
      const root = this.root;
      this.playIo = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) root.removeAttribute('data-offscreen');
        else root.setAttribute('data-offscreen', '');
      });
      this.playIo.observe(root);
    }
  }

  customElements.define('op-where-to-buy', OpWhereToBuy);
})();
